module.exports = __webpack_public_path__ + "static/instruction1.b79f2991.svg";